import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.ROUTER_BASE,
    routes: [
        // {
        //   path: '/',
        //   name: 'HelloWorld',
        //   component: HelloWorld
        // },
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'index',
            component: () =>
                import('@/views/dljnhs/index'),
            meta: {
                pageTitle: '首页'
            }
        },

        {
            path: '/dljnhs_detail/:listName/:index',
            name: 'dljnhs_detail',
            component: () =>
                import('@/views/dljnhs/dljnhs_detail'),
            meta: {
                pageTitle: '详情'
            }
        },

        {
            path: '/picshow',
            name: 'picshow',
            component: () => import('@/views/dljnhs/picshow'),
            meta: {
                pageTitle: '“文化和自然遗产日”宣传展示矩阵'
            }
        },

        {
            path: '/market',
            name: 'market',
            component: () => import('@/views/dljnhs/market'),
            meta: {
                pageTitle: '城市文旅融合市集'
            }
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js